module.exports = __webpack_public_path__ + "media/theme/sc_psn-43271855.png";